import React from "react";

function Experience() {
  return (
    <div className="center">
      <div>
        <div>
          <h2><u>Work and Volunteering</u></h2>
        </div>
        <div className="left-align">
          <div>
            <h3>Leading PLM Analyst</h3>
            <h4>International Asbestos Laboratories</h4>
            <h5>2019-Present</h5>
          </div>
          <ul>
            <li>
              Steered and Engineered the company's first comprehensive
              cloud-based, employee training platform; streamlining resources
              through digitization, comprehensive UI, and responsive design.
            </li>
            <li>
              Spearheaded development of analytical Standard Operating
              Procedures (SOPs), driving efficient departmental workflow and
              adhering to health & safety policies.
            </li>
          </ul>
        </div>
        <div className="divider" />
        <div className="left-align">
          <div>
            <h3>GIS Analyst / Drone Co-Pilot</h3>
            <h4>Duke University MaRRs Lab</h4>
            <h5>2018</h5>
          </div>
          <ul>
            <li>
              Strategically programmed drone flight paths, saw, and increased
              quality of multi-spectral image mosaics using software suites
              (PIX4D, ESRI Arcmap), improving minute measurements considerably.
            </li>
            <li>
              Delivered impactful analytic insights to government stakeholders,
              fostering aquaculture site rejuvenation and contributing to
              restoration of public marine areas.
            </li>
          </ul>
        </div>
        <div className="divider" />
        <div className="left-align">
          <div>
            <h3>Site Geologist</h3>
            <h4>Emerald Hollow Mine, LLC</h4>
            <h5>2015 - 2017</h5>
          </div>
          <ul>
            <li>
              Unwavering commitment to making beautiful products resulted in
              over 9000 top-tier cabochon gemstones, as well as collaborating
              seamlessly with fellow geologists to exceed stringent state
              regulatory benchmarks.
            </li>
            <li>
              Provided educational experiences to school groups and tourists
              interested in geology, mining, and relevant history.{" "}
            </li>
          </ul>
        </div>
        <div>
          <a
            href="https://docs.google.com/document/d/1Vje3AEc4ljenISyJjLVpy9ByVyoiplgE/edit?usp=sharing&ouid=117525258448058942395&rtpof=true&sd=true"
            target="_blank"
          >
            <h2> View my full resumé here</h2>
          </a>
        </div>
      </div>
    </div>
  );
}
export default Experience;
